// NEVO-439 - Limitar ACVC post portal único: la pestaña "Configuración de correos" se elimina
// exclusivamente para los perfiles de Empresas Instaladoras (captadoras) y Gremios. Se mantiene
// para Comercializadoras, Prescriptores y empresas instaladoras dedicadas únicamente a IP/JCA.
const MAILING_CONFIG_EXCLUDED_ROLES = {
  gremio: true,
  instalador: true,
  administrador: true,
  administrador_grabador: true,
  admin_captador_grabador: true,
  instalador_captador_grabador: true,
}

export const canAccessMailingConfig = (role) => !MAILING_CONFIG_EXCLUDED_ROLES[role]

const IS_PRESCRIPTOR = (role) => role === 'administrador_prescriptor'

export const PROFILE_TABS_CONFIG = ({ intl, role }) =>
  [
    { id: 'user', label: intl.formatMessage({ id: 'pages.profile.tabs.user.title' }) },
    {
      id: 'change-password',
      label: intl.formatMessage({ id: 'pages.profile.tabs.password.title' }),
    },
    {
      id: 'company',
      label: intl.formatMessage({
        id: IS_PRESCRIPTOR(role)
          ? 'pages.profile.tabs.company.prescriptor.title'
          : 'pages.profile.tabs.company.title',
      }),
    },
    {
      id: 'adhesion-op',
      label: intl.formatMessage({ id: 'pages.profile.tabs.adhesion-op.title' }),
      prescriptorOnly: true,
    },
    { id: 'mailing', label: intl.formatMessage({ id: 'pages.profile.tabs.mailing.title' }) },
  ].filter((tab) => {
    if (tab.id === 'mailing') return canAccessMailingConfig(role)
    if (tab.prescriptorOnly) return IS_PRESCRIPTOR(role)
    return true
  })
